export const formatListStyleAsHtml = (text: string) => {
  let formatText = text;

  if (formatText.includes('<p>')) {
    formatText = formatText.replace('<p>', '<p style="font-size: 1rem;">');
  }

  if (formatText.includes('<ul>')) {
    formatText = formatText.replace(
      '<ul>',
      '<ul style="list-style-type: disc; padding-left: 1.25rem; font-size: 1rem;">'
    );
  }

  if (formatText.includes('<ol>')) {
    formatText = formatText.replace('<ol>', '<ol style="list-style-type: decimal; padding-left: 1.25rem;">');
  }

  return formatText;
};
